import { render, staticRenderFns } from "./FrontVersionChecker.vue?vue&type=template&id=0384ce80"
import script from "./FrontVersionChecker.vue?vue&type=script&lang=js"
export * from "./FrontVersionChecker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports